/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
// import {FormTypeChild} from './form-type-child.model';


export class FormTypeChild {
    id: string; // ecf001
    title: string; // ecf001
    code: string; // ecf001
    description: string; // ecf001
    children: FormTypeChild[]; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): FormTypeChild {
        if (!data) { return instance; }
        if (data.id != null) {instance.id = data.id; }
        if (data.title != null) {instance.title = data.title; }
        if (data.code != null) {instance.code = data.code; }
        if (data.description != null) {instance.description = data.description; }
        if (data.children != null) {
            instance.children = [];
            ([].concat(data.children)).forEach(occurrence => {
                instance.children.push(new FormTypeChild().fromJSON(occurrence)); // i3
            });
        }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return FormTypeChild.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: FormTypeChild) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return FormTypeChild.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: FormTypeChild): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
